// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../controllers"

// Import js route helpers
import * as Routes from '../js/routes.js.erb';
window.Routes = Routes;

//Import js files
import '../js/jquery_bootstrap.js'
import '../js/bootstrap_js_files.js'
import '../js/application.js'
import '../js/calendar.js'
import '../js/favorite_ort_list.js'
import '../js/main_city.js'
import '../js/entdecken.js'
import '../js/event.js'
import '../js/search.js'
import '../js/neues.js'
import '../js/more_menu.js'
import '../js/garbage.js'
import '../js/settings.js'
import 'leaflet/dist/leaflet'
import '../js/lwconnect.js'
import '../js/jobs.js'
import '../js/magazines.js'
import '../js/poi_maps.js'
import '../js/contact_form.js'
import '../js/share_options.js'
import '../js/home_map.js'
import '../js/survey.js'
import '../js/chat.js'
import '../js/matomo_client.js'
import '../js/kirche.js'

// Import css files
import 'packs/application.scss'
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightbox2/src/css/lightbox.css'
import '../styles/date_range_picker.scss'
import 'swiper/swiper.min.css';


// Import static files
const images = require.context("../images", true)
const imagePath = name => images(name, true)

Rails.start()
ActiveStorage.start()
